import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./style.scss";
const HeroBanner = props => {
  const { fields } = props;
  const { image_pc, image_mobile, image_align, title } = fields;
  const [bg, setBg] = useState(image_pc.value?.src ?? image_mobile.value?.src);
  const onResize = () => {
    const isMobile = window.innerWidth < 992;
    if (isMobile && image_mobile.value?.src) {
      setBg(image_mobile.value?.src);
    }
    if (!isMobile && image_pc.value?.src) {
      setBg(image_pc.value?.src);
    }
  };
  const rootClass = classNames("c-hero-banner", image_align ? `bg-${image_align.fields.phrase.value}` : "");
  useEffect(() => {
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  return (
    <div className={rootClass} style={{ backgroundImage: `url(${bg})` }}>
      <div className="c-hero-banner__content grid">
        <h1 className="c-hero-banner__title">{title?.value}</h1>
      </div>
    </div>
  );
};
export default HeroBanner;
